import type { ApiResponse } from "@/types/api";
import { getClient } from "@/services/ApiService";

const secured = () => getClient();

const msgRequest = {
  request: {
    async getMessageList(
      facilityKey: string,
      patientKey: string,
      payload?: { includeArchived?: boolean }
    ): Promise<ApiResponse> {
      return secured().post(
        `/Portal/GetMessageList/${encodeURIComponent(facilityKey)}/${encodeURIComponent(patientKey)}`,
        payload ?? {}
      );
    },

    async setMessageAsRead(facilityKey: string, payload: { id?: string }): Promise<ApiResponse> {
      return secured().post(
        `/Portal/UpdateMessageRead/${encodeURIComponent(facilityKey)}`,
        payload
      );
    },

    async getMessageThread(
      facilityKey: string,
      patientKey: string,
      payload: { parentId?: string }
    ): Promise<ApiResponse> {
      return secured().post(
        `/Portal/GetMessageThread/${encodeURIComponent(facilityKey)}/${encodeURIComponent(patientKey)}`,
        payload
      );
    },

    async insertMessageReply(
      facilityKey: string,
      patientKey: string,
      payload: { parentId?: string; message?: string }
    ): Promise<ApiResponse> {
      return secured().post(
        `/Portal/InsertMessageReply/${encodeURIComponent(facilityKey)}/${encodeURIComponent(patientKey)}`,
        payload
      );
    },

    async archiveMessage(facilityKey: string, payload: { id?: string }): Promise<ApiResponse> {
      return secured().post(
        `/Portal/ArchiveMessage/${encodeURIComponent(facilityKey)}`,
        payload
      );
    },

    async getArchivedMessageCount(
      facilityKey: string,
      patientKey: string
    ): Promise<ApiResponse> {
      return secured().get(
        `/Portal/GetArchivedMessageCount/${encodeURIComponent(facilityKey)}/${encodeURIComponent(patientKey)}`
      );
    },

    async insertMessage(
      facilityKey: string,
      patientKey: string,
      payload: { subject?: string; message?: string }
    ): Promise<ApiResponse> {
      return secured().post(
        `/Portal/InsertMessage/${encodeURIComponent(facilityKey)}/${encodeURIComponent(patientKey)}`,
        payload
      );
    },

    async getUnReadMessageCount(
      facilityKey: string,
      patientKey: string
    ): Promise<ApiResponse> {
      return secured().get(
        `/Portal/GetUnreadMessageCount/${encodeURIComponent(facilityKey)}/${encodeURIComponent(patientKey)}`
      );
    },

    async updateMessageRead(
      facilityKey: string,
      payload: { id?: string; read?: boolean }
    ): Promise<ApiResponse> {
      return secured().post(
        `/Portal/UpdateMessageRead/${encodeURIComponent(facilityKey)}`,
        payload
      );
    },
  },
};

export default msgRequest;
